import React, { useState } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import Logo from '../assets/logo.svg';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="navbar-container ">
      {/* Nav con position relative para que el menú móvil se posicione debajo */}
      <nav
        style={{
          position: 'fixed',
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between', // Distribuye las tres secciones
          alignItems: 'center',
          zIndex: 1000, // Asegura que el navbar esté encima de otros elementos
          top: 0,
          left: 0,
          backgroundColor: '#010630',
          padding: '0.5rem 1rem',
        }}
      >
        {/* Logo a la izquierda */}
        <div className='p-2'>
          <a href="https://bscolombia.com.co/" target="_blank" rel="noopener noreferrer">
            <img  src={Logo} alt="logo" className="h-10 object-contain" />
          </a>
        </div>

        {/* Menú Desktop (horizontal) */}
        <div
          className="hidden md:flex flex-1 justify-center items"
          style={{ /* Mantén tus estilos en línea si deseas */ }}
        >
          <ul
            className="flex flex-row space-x-8 font-sans"
            style={{ fontSize: 'clamp(12px,1.1vw,2vw)' }}
          >
            <li>
              <a href="#inicio">Inicio</a>
            </li>
            <li>
              <a href="#argument">Acerca de</a>
            </li>
            <li>
              <a href="https://bscolombia.com.co/blog-business-support/mentor-ia">Blog</a>
            </li>
            <li>
              <a href="#contacto">Contacto</a>
            </li>
       
          </ul>
        </div>

        {/* Botón a la derecha (visible sólo en desktop) */}
        <div className="flex items-center space-x-2">
        <button
  className="btn-primary md:inline-flex flex items-center"
  type="button"
  style={{ fontSize: 'clamp(12px,1.1vw,1.2vw)' }}
  onClick={() => window.open("https://wa.me/573155381468?text=Hola,%20necesito%20informaci%C3%B3n%20sobre%20MentorIA", "_blank")}
>
  Contactar un Asesor
  <FaWhatsapp className="ml-2" style={{ color: 'white', fontSize: '1.2em' }} />
</button>


          {/* Botón hamburguesa (visible sólo en mobile) */}
          <button
            onClick={toggleMenu}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100
                          focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-sticky"
            aria-expanded={isMenuOpen}
          >
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          
        </div>
        
        {/* Menú Mobile (columna). Aparece sólo si isMenuOpen = true */}
        {isMenuOpen && (
          <div
            className="md:hidden bg-dark "
            style={{
              position: 'absolute',
              top: '100%', // Justo debajo del nav
              right: 0,
              marginTop: '0.5rem',
              width: 'auto',
              padding: '1rem 1.5rem',
              zIndex:"9999",
              opacity: 0.8
            }}
          >
            <ul
              className="flex flex-col space-y-3 font-sans text-white"
              style={{ fontSize: 'clamp(10px,0.8vw,1vw)' }}
            >
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}>
                <a href="#inicio">Inicio</a>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}>
                <a href="#argument">Acerca de</a>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}>
                <a href="https://bscolombia.com.co/blog-business-support/mentor-ia">Blog</a>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}>
                <a href="#contacto">Contacto</a>
              </li>
           
            </ul>
          </div>
        )}
      </nav>
      
    </header>
    
  );
};

export default Header;